export var SELECTORS = {
    MINI_CART_BUTTON: '.wp-block-glimp-mini-cart',
    MINI_CART_ELEMENT: '.mini-cart',
    CART_LIST: '.mini-cart__list',
    CART_ITEM: '.mini-cart__item',
    CART_ITEM_KEY: 'data-key',
    CART_ITEM_QUANTITY: '.mini-cart__item-quantity',
    CART_ITEM_QUANTITY_BUTTON_DECREASE: '.mini-cart__item-quantity-button_decrease',
    CART_ITEM_QUANTITY_BUTTON_INCREASE: '.mini-cart__item-quantity-button_increase',
    CART_ITEM_QUANTITY_INPUT: '.mini-cart__item-quantity-input',
    CART_ITEM_RETURN: '.mini-cart__item-return',
    CART_ITEM_DETAILS: '.mini-cart__item-details',
    CART_ITEM_IMAGE: '.mini-cart__item-image',
    CART_ITEM_INFO: '.mini-cart__item-info',
    CART_ITEM_TITLE: '.mini-cart__item-title',
    CART_ITEM_DESCRIPTION: '.mini-cart__item-description',
    CART_ITEM_PRICE: '.mini-cart__item-price',
    CART_ITEM_TIMER: '.mini-cart__item-timer',
    CART_ITEM_GIFT: 'mini-cart__item_gift',
    MINI_CART_TOTAL: '.mini-cart__total-value',
    MINI_CART_COUNTER: '.wp-block-glimp-mini-cart__count',
    MINI_CART_CHECKOUT: '.mini-cart__checkout',
    MINI_CART_CLOSE: 'mini-cart__close',
    MINI_CART_FOOTER_COUNTER: '.mini-cart__footer-counter',
    MINI_CART_PROGRESS_MIN_AMOUNT_BAR: 'input.to-min-amount',
    MINI_CART_PROGRESS_FREE_SHIPPING_BAR: 'input.to-free-shipping',
    MINI_CART_PROGRESS_GIFT_BAR: '.mini-cart__counter-progress-input.to-free-gift',
    MINI_CART_PROGRESS_REMAINING: '.mini-cart__counter-value',
    MINI_CART_PROGRESS_TEXT: '.mini-cart__counter-label',
    MINI_CART_CROSS_SELLS: '.mini-cart__cross-sells',
    MINI_CART_CROSS_SELLS_WRAPPER: '.mini-cart__cross-sells__wrapper',
    MINI_CART_CROSS_SELLS_ITEM: '.mini-cart__cross-sells-item',
    MINI_CART_CROSS_SELLS_ITEM_LINK: '.mini-cart__cross-sells-item__link',
    MINI_CART_CROSS_SELLS_ITEM_IMAGE: '.mini-cart__cross-sells-item__image',
    MINI_CART_CROSS_SELLS_ITEM_INFO: '.mini-cart__cross-sells-item__info',
    MINI_CART_CROSS_SELLS_ITEM_NAME: '.mini-cart__cross-sells-item__name',
    MINI_CART_CROSS_SELLS_ITEM_PRICE: 'mini-cart__cross-sells-item__price',
    MINI_CART_COUPON_BLOCK: '.mini-cart__coupon',
    MINI_CART_COUPON_FORM: '.mini-cart__coupon-form',
    MINI_CART_COUPON_OPENER: '.mini-cart__coupon-opener',
    MINI_CART_COUPON_SUBMIT: '.mini-cart__coupon-submit',
    MINI_CART_COUPON_APPLIED: '.mini-cart__coupon-applied',
    MINI_CART_COUPON_APPLIED_REMOVE: '.mini-cart__coupon-applied-remove',
    MINI_CART_COUPON_APPLIED_AMOUNT: 'mini-cart__coupon-applied-amount',
    MINI_CART_COUPON_APPLIED_DESCRIPTION: 'mini-cart__coupon-applied-description',
    MINI_CART_NOTICES: '.mini-cart__notices',
    MINI_CART_NOTICE: 'mini-cart__notice',
    MINI_CART_COIN_CONTAINER: '.mini-cart__coin',
    MINI_CART_COIN_CHECKBOX: '.mini-cart__coin-checkbox-input',
};
